var ServicesStatusBoardConstants = {

    INIT: 'init',
    CHANGE_EVENT: 'changeEvent',
    GOTO_DATE: 'gottoDate',
    
};

export default ServicesStatusBoardConstants